import { generatePath as baseGeneratePath, createSearchParams, } from "@madmedical/routing";
import { useAppConfig } from "@madmedical/config";
import { useCallback } from "react";
import useAdminPatientId from "../useAdminPatientId";
import useRoutePaths from "./useRoutePaths";
export default () => {
    const { basePath } = useAppConfig();
    const { getPath } = useRoutePaths();
    const patientId = useAdminPatientId();
    return useCallback((route, params, search) => `${basePath}/${baseGeneratePath(getPath(route), Object.assign({ patientId }, params))}${search ? `?${createSearchParams(search).toString()}` : ""}`, [basePath, getPath, patientId]);
};
